import classNames from 'classnames';
import React from 'react';
import { Logo } from '../../../../../layout/BotBuilderSidebar/Logo/Logo';
import { HEADER_STEPS } from '../constants';
import styles from '../WebsiteReportSummaryVersionA.module.css';

export const ReportHeader = ({
  activeStep,
  isElegibleForDemo,
}: {
  activeStep: number;
  isElegibleForDemo?: boolean | null;
}) => {
  const steps = HEADER_STEPS.filter(step =>
    !isElegibleForDemo ? step.step !== 3 : true,
  );
  return (
    <div className={classNames(styles.row, styles.headerContainer)}>
      <Logo />
      <div className={classNames(styles.row, styles.headerContent)}>
        <div className={classNames(styles.row, styles.steps)}>
          {steps.map((item, idx) => {
            const stepNumber = idx + 1;
            return (
              <React.Fragment key={stepNumber}>
                <div
                  key={stepNumber}
                  className={classNames(styles.step, {
                    [styles.inactiveStep]: activeStep !== stepNumber,
                  })}
                >
                  Step {stepNumber}. {item.title}
                </div>
                {stepNumber !== steps.length && (
                  <div className={styles.dashes} />
                )}
              </React.Fragment>
            );
          })}
        </div>
      </div>
    </div>
  );
};
